<template>
  <div class="online-button-wrapper">
    <div class="verification-wrapper" v-if="verificationRequired">
      <button class="online-button primary-button" @click="onClick">
        {{ $t("discount.buttons.getDiscountOnline") }}
      </button>
      <redirect-voucher-dialog v-if="redirectWizardOpened"
        :redirect-url="redirectUrl" />
    </div>
    <a v-else :href="redirectUrl" target="_blank" @click="onRedirectLinkClick"
        class="online-button primary-button">
      {{ $t("discount.buttons.getDiscountOnline") }}
    </a>
  </div>
</template>

<style scoped>
  @import '../../assets/css/button-style.css';

  .primary-button {
    margin: 16px 0 8px 0;
    max-width: 200px;
    margin-right: 16px;
  }
</style>

<script>
import { mapActions, mapState } from 'vuex';
import RedirectVoucherDialog from '@/components/vouchers/RedirectVoucherDialog.vue';

export default {
  name: 'online-discount-button',
  props: {
    verificationRequired: {
      type: Boolean,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: true,
    },
    onClick: {
      type: Function,
      required: true,
    },
    benefit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      redirectWizardOpened: (state) => state.voucher.redirectWizardOpened,
    }),
  },
  methods: {
    ...mapActions({
      createBenefitEvents: 'createBenefitEvents',
      openMobileOnlyDialog: 'openMobileOnlyDialog',
    }),
    onRedirectLinkClick(e) {
      // Prevent benefit event create and redirect if is mobile only benefit.
      if (this.benefit.mobileOnly) {
        e.preventDefault();
        this.openMobileOnlyDialog();
        return;
      }

      this.createBenefitEvents({
        benefits: [this.benefit],
        eventType: 'REDEMPTION',
        data: {
          redemptionType: 'REDIRECT',
        },
      });
    },
  },
  components: {
    RedirectVoucherDialog,
  },
};
</script>
